<template>
  <v-main>
    <v-layout fill-height column align-center justify-center>
      <v-container class="error-container">
        <div class="guide">
          <v-img :src="getImage(guideInfo.questionApp)" max-width="130px" class="mx-auto mb-3" />
        </div>
        <h2>혹시 앱스토어 화면이 안보이세요?</h2>
        <p>
          앱스토어 화면이 보이지 않는 분은<br />
          아래의 버튼을 통해 앱스토어로 이동해 주세요.
        </p>
        <v-btn elevation="0" min-width="140px" color="primary" class="mt-5">
          <span class="fs-14" @click="open">앱스토어 이동</span>
        </v-btn>
      </v-container>
    </v-layout>
  </v-main>
</template>

<script>
import {mixinRemote} from "@/mixins";
export default {
  name: "AppStoreIndex",
  mixins: [mixinRemote],
  computed: {
    checkKakao() {
      let userAgent = navigator.userAgent.toLowerCase();
      return !!userAgent.match(/kakaotalk/i);
    },
  },
  created() {
    let userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("android") >= 0) this.openAOSAppStore();
    else this.openIOSAppStore();
  },
  methods: {
    open() {
      let userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("android") >= 0) this.openAOSAppStore();
      else this.openIOSAppStore();
    },
    openAOSAppStore() {
      if (this.checkKakao) {
        window.open(
            'kakaotalk://web/openExternal?url=https://play.google.com/store/apps/details?id=com.ezn.dms.user&hl=ko'
        );
      } else {
        window.location.href = 'https://play.google.com/store/apps/details?id=com.ezn.dms.user&hl=ko';
      }
    },
    openIOSAppStore() {
      if (this.checkKakao) {
        window.open(
            `kakaotalk://web/openExternal?url=https://apps.apple.com/app/id1671479927`
        );
      } else {
        window.location.href = 'https://apps.apple.com/app/id1671479927'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.error-container {
  padding-bottom: 60px;
  text-align: center;
  color: #999;
  h2 {
    margin-bottom: 5px;
    font-weight: 600;
    font-size: 18px;
    color: #333;
  }
}
</style>
